$(document).ready(function(){

    $('.bandeau-slideshow').slideShow6tk({
        easing              : false,
        pauseOnHover        : true,
        animation           : "fade",
        autoHeight          : false,
        slideshowSpeed      : 2500,
        animationSpeed      : 400,
        autoPlay            : true,
        navigation          : false,
        generateNavigation  : false,
        pagination          : true,
        generatePagination  : true,
        paginationClass     : "tematik_slideshow-pagin"
    });
    
});